module.exports = __webpack_public_path__ + "static/media/face3.16c67435.jpg";